import { Alert, Collapse, Stack, Typography, useTheme } from "@mui/material"
import { ReactElement, useContext } from "react"

import { ReactComponent as ChecklistSvg } from "../../../assets/checklist.svg"
import useConfirmSetUp, {
    MANUAL_SET_UP,
} from "../../../services/middleware/hooks/account/useConfirmSetUp"
import AppButton from "../../buttons/appButton"
import AppLoadingButton from "../../buttons/appLoadingButton"
import CheckMarkList from "../../dataDisplay/lsits/checkMarkList"
import { BUTTON_SPACING } from "../common/config"
import FullScreenTitleContent from "../common/fullScreenTitleContent"
import { AccountSetUpContext } from "../providers/firstLoginProvider"
import { EXISTING_DEVICES_CHECK } from "../screenDispatchers/firstLoginConstants"

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: Unreachable code error
// eslint-disable-next-line no-undef
const CONFIG = GLOBAL_CONFIG

/** Displayed to manufacturers to check if they have existing devices */
const HasExistingDevices = (): ReactElement => {
    const { setCurrentScreen } = useContext(AccountSetUpContext)
    const { isConfirming, error, patchConfirmSetUp } =
        useConfirmSetUp(MANUAL_SET_UP)
    const theme = useTheme()
    return (
        <FullScreenTitleContent
            titlePrimaryColor=""
            titleMain="We need to carry out a few additional checks to get you access to your data"
            subtitle="These checks won’t take too long, but are vital so we can confirm your existing data is protected and secure"
            customSvg={
                <ChecklistSvg
                    fill={theme.palette.primary.dark}
                    viewBox="-125 75 800 400"
                />
            }
            content={
                <>
                    <Typography
                        variant="h6"
                        fontWeight={400}
                        color="text.secondary"
                    >
                        These checks won’t take too long, but are vital so we
                        can confirm your existing data is protected and secure.
                        Once complete, you will be set up as an admin for your
                        organisation and be able to access your data.
                    </Typography>
                    <Typography
                        variant="h6"
                        fontWeight={400}
                        color="text.secondary"
                    >
                        To progress these checks, can you please:
                    </Typography>
                    <CheckMarkList
                        secondary
                        variant="h6"
                        fontWeight={400}
                        items={[
                            "Click continue below",
                            "This will direct you to our support portal",
                            "Raise a ticket asking for you your organisation to be set up. Please specify that you are a manufacturer, that you have existing devices and some sample device references",
                        ]}
                    />
                    <Typography
                        variant="h6"
                        fontWeight={400}
                        color="text.secondary"
                    >
                        Once done, we will:
                    </Typography>
                    <CheckMarkList
                        secondary
                        variant="h6"
                        fontWeight={400}
                        items={[
                            "Validate your details",
                            "Create your organisation and set you up as the admin",
                        ]}
                    />
                </>
            }
            actionContent={
                <Stack width="100%" spacing={BUTTON_SPACING}>
                    <Collapse in={!!error}>
                        <Stack width="100%" spacing={BUTTON_SPACING}>
                            <Alert severity="warning">
                                {error?.displayDetail}
                            </Alert>
                            <AppButton
                                fullWidth
                                variant="outlined"
                                color="warning"
                                onClick={() =>
                                    window.open(CONFIG.SN_PORTAL_URL, "_blank")
                                }
                                disabled={isConfirming}
                            >
                                Support Portal
                            </AppButton>
                        </Stack>
                    </Collapse>
                    <AppLoadingButton
                        fullWidth
                        variant="contained"
                        loading={isConfirming}
                        onClick={() => {
                            patchConfirmSetUp()
                            window.open(CONFIG.SN_PORTAL_URL, "_blank")
                        }}
                    >
                        Complete set up and go to Support Portal
                    </AppLoadingButton>
                    <AppButton
                        fullWidth
                        variant="outlined"
                        disabled={isConfirming}
                        onClick={() => setCurrentScreen(EXISTING_DEVICES_CHECK)}
                    >
                        Back
                    </AppButton>
                </Stack>
            }
        />
    )
}

export default HasExistingDevices
